import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfiguration } from '../../../core/models/app-configuration.model';
import { Expiry, ExpiryValidityRanges } from './expiry.model';

/**
 * Expiry Service
 * @description Angular service implements method for get and update expiration configuration
 */

@Injectable({ providedIn: 'root' })
export class ExpiryService {
  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfiguration) { }

  getResourceUrl(): string {
    return this.appConfig.serverApiUrl + '/api/v1/password/expiration/config';
  }

  /**
   * Get expiry notification configuration
   */
  getExpirationConfig(): Observable<Expiry> {
    return this.http.get<Expiry>(this.getResourceUrl());
  }

  /**
   * Filters expiry ranges to ones that fit the current password duration
   * and get the recomended alert of the last one
   * @param expiry Password expiration settings @see Expiry
   * @param currentPwdDurationDays Password duration in days before expiry
   * @returns number of days before password expiration wen notification should be displayed
   */
  getDefaultAdviceEvery(expiry: Expiry, currentPwdDurationDays: number): number | undefined {
    let result;
    if (expiry.validityRanges) {
      result = expiry.validityRanges
        .filter(
          (singleRange: ExpiryValidityRanges) =>
            currentPwdDurationDays >= singleRange.minDays && currentPwdDurationDays <= singleRange.maxDays
        )
        .pop()?.recommendedAlert;
    }

    return result;
  }

  /**
   * Save new Expiry notification configuration
   * @param expiry
   */
  save(expiry: Expiry): Observable<Expiry> {
    return this.http.put<Expiry>(this.getResourceUrl(), expiry);
  }
}
